import { ALL_JOB_SWMS_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const USE_MOCK = process.env.NODE_ENV !== "production"
  && process.env.REACT_APP_USE_EMERGENCY_MOCKS === "true";

const SAMPLE_READINESS_QUESTIONS = [
  {
    id: 2,
    emergency_plan_id: 5,
    question_text: "New Test Question 33",
    guidance_text: null,
    answer_scope: "supervisor",
    response_config: {
      type: "number",
      unit: "km/h",
      schemaVersion: 1
    },
    display_order: 1,
    required: false,
    active: true,
    created_by: 7666793086,
    created_at: "2026-09-05T00:54:16.000Z",
    modified_by: 7666793086,
    modified_at: "2026-09-05T01:47:32.000Z"
  },
  {
    id: 1,
    emergency_plan_id: 5,
    question_text: "New Test Question",
    guidance_text: "asdad",
    answer_scope: "supervisor",
    response_config: {
      type: "radio",
      options: [
        {
          label: "Yes",
          value: "yes"
        },
        {
          label: "No",
          value: "no"
        }
      ],
      flagOnValue: "yes",
      schemaVersion: 1
    },
    display_order: 2,
    required: true,
    active: true,
    created_by: 7666793086,
    created_at: "2026-09-05T00:47:23.000Z",
    modified_by: 7666793086,
    modified_at: "2026-09-05T01:47:32.000Z"
  },
  {
    id: 4,
    emergency_plan_id: 5,
    question_text: "Has rescue equipment been inspected?",
    guidance_text: "Check service date and storage condition.",
    answer_scope: "supervisor",
    response_config: {
      type: "radio",
      options: [
        {
          label: "Yes",
          value: "yes"
        },
        {
          label: "No",
          value: "no"
        }
      ],
      flagOnValue: "no",
      schemaVersion: 1
    },
    display_order: 3,
    required: true,
    active: false,
    created_by: 4585037894,
    created_at: "2026-09-05T01:26:23.000Z",
    modified_by: 4585037894,
    modified_at: "2026-09-05T02:23:24.000Z"
  },
  {
    id: 3,
    emergency_plan_id: 5,
    question_text: "New Plan",
    guidance_text: "Okay",
    answer_scope: "supervisor",
    response_config: {
      type: "radio",
      options: [
        {
          label: "Yes",
          value: "yes"
        },
        {
          label: "No",
          value: "no"
        },
        {
          label: "N/A",
          value: "not_applicable"
        }
      ],
      flagOnValue: null,
      schemaVersion: 1
    },
    display_order: 4,
    required: true,
    active: true,
    created_by: 7666793086,
    created_at: "2026-09-05T00:55:43.000Z",
    modified_by: 7666793086,
    modified_at: "2026-09-05T01:47:32.000Z"
  },
  {
    id: 5,
    emergency_plan_id: 5,
    question_text: "New Test Question",
    guidance_text: null,
    answer_scope: "supervisor",
    response_config: {
      type: "radio",
      options: [
        {
          label: "Yes",
          value: "yes"
        },
        {
          label: "No",
          value: "no"
        }
      ],
      flagOnValue: null,
      schemaVersion: 1
    },
    display_order: 5,
    required: true,
    active: true,
    created_by: 3053035670,
    created_at: "2026-09-05T02:23:59.000Z",
    modified_by: 3053035670,
    modified_at: "2026-09-05T02:23:59.000Z"
  }
];

const getMockEmergencyReadiness = () => Promise.resolve({
  exists: true,
  toggle: 1,
  document: {
    questions: SAMPLE_READINESS_QUESTIONS
  }
});

export const getJobSwmsEmergencyReadiness = (abortController, swmsId, jobId) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  if (USE_MOCK) {
    return getMockEmergencyReadiness();
  }

  return scopeApiInstance.get(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/rescue-readiness-questions`, { ...abortController })
    .then((res) => {
      if (res && res.data && res.data.data) {
        return Promise.resolve(res.data.data);
      }

      return Promise.reject(Strings.generic_error);
    })
    .catch((error) => Promise.reject(
      error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : Strings.network_error
    ));
};

export const saveJobSwmsEmergencyReadiness = (jobId, swmsId, readinessPayload) => () => {
  if (swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  if (USE_MOCK) {
    return Promise.resolve({
      message: "Emergency Readiness saved successfully.",
      emergency_readiness: readinessPayload,
      version_created: false
    });
  }

  return scopeApiInstance.put(
    `${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/rescue-readiness-questions`,
    { emergency_readiness: readinessPayload }
  ).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(
    error && error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : Strings.network_error
  ));
};
